module.exports = __webpack_public_path__ + "img/dj.9d63994b.svg";